
import React, { useState } from 'react';
import { useMasterLicense } from '@/hooks/useMasterLicense';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search, Filter } from 'lucide-react';
import LicenseKeysHeader from '@/components/masterlicense/LicenseKeysHeader';
import LicenseKeyTable from '@/components/masterlicense/LicenseKeyTable';
import CreateLicenseDialog from '@/components/masterlicense/CreateLicenseDialog';
import MasterLicenseLayout from '@/components/masterlicense/MasterLicenseLayout';
import { LicenseFormValues } from '@/components/masterlicense/CreateLicenseForm';

const MasterLicenseKeys = () => {
  const {
    isLoading,
    licenseKeys,
    filteredLicenseKeys,
    searchQuery,
    setSearchQuery,
    handleLogout,
    handleCreateLicense,
    handleSuspendLicense,
    handleReactivateLicense,
    handleDeleteLicense,
    isCreatingLicense
  } = useMasterLicense();

  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  // Wrapper function to adapt the types
  const createLicense = async (data: LicenseFormValues): Promise<void> => {
    await handleCreateLicense({
      domain: data.domain,
      plan: data.plan,
      expiresAt: data.expiresAt,
      notes: data.notes
    });
  };

  return (
    <MasterLicenseLayout isLoading={isLoading} onLogout={handleLogout} activeTab="license-keys">
      <div className="max-w-7xl mx-auto">
        <LicenseKeysHeader onCreateDialogOpen={() => setIsCreateDialogOpen(true)} />

        <div className="mb-6 flex flex-col sm:flex-row justify-between gap-4">
          <div className="relative w-full sm:w-auto">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <Input
              placeholder="Search license keys..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-10 w-full sm:w-80"
            />
          </div>
          <Button variant="outline" className="flex items-center gap-2">
            <Filter className="h-4 w-4" />
            Filter
          </Button>
        </div>

        <LicenseKeyTable
          licenseKeys={filteredLicenseKeys}
          onSuspendLicense={handleSuspendLicense}
          onReactivateLicense={handleReactivateLicense}
        />

        <CreateLicenseDialog
          open={isCreateDialogOpen}
          onOpenChange={setIsCreateDialogOpen}
          onCreateLicense={createLicense}
          isCreatingLicense={isCreatingLicense}
        />
      </div>
    </MasterLicenseLayout>
  );
};

export default MasterLicenseKeys;
